import { useMemo } from "react";
import {
  CodeBlock,
  CodeBlockActions,
  CodeBlockContent,
  CodeBlockHeader,
  CodeBlockTitle,
} from "@/components/ui/code-block";
import { CopyButton } from "@/components/ui/copy-button";
import { formatValue } from "./format";

/** One labelled value (input / output / error) as a small code block. */
export function ValueBlock({ label, value, error }: { label: string; value: unknown; error?: boolean }) {
  // Memoized: an open panel would otherwise re-stringify large payloads on
  // every stream event.
  const text = useMemo(() => formatValue(value), [value]);
  return (
    <CodeBlock size="sm" variant={error ? "destructive" : "default"}>
      <CodeBlockHeader>
        <CodeBlockTitle>{label}</CodeBlockTitle>
        <CodeBlockActions>
          <CopyButton
            textToCopy={text}
            buttonText=""
            variant="ghost"
            tooltipText={`Copy ${label.toLowerCase()}`}
            scope={false}
            tooltipDelay={500}
            className="size-7 rounded-sm text-muted-foreground hover:text-foreground"
          />
        </CodeBlockActions>
      </CodeBlockHeader>
      <CodeBlockContent wrap className="max-h-64">
        {text}
      </CodeBlockContent>
    </CodeBlock>
  );
}
